<template>
  <AuthLayout>
    <div class="w-full text-center space-y-4">
      <h1 class="text-2xl font-extralight text-gray-200 font-mind-force">
        Validando acesso
      </h1>

      <p v-if="loading" class="text-gray-400">
        Aguarde enquanto verificamos seu link...
      </p>

      <p v-if="errorMessage" class="text-red-400">
        {{ errorMessage }}
      </p>
    </div>
  </AuthLayout>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import AuthLayout from "@/layouts/AuthLayout.vue";
import { resolveInvite } from "@/services/public/publicFormService";
import {
  clearCollaboratorSession,
  setCollaboratorInviteContext,
  getCollaboratorDoneKey,
} from "@/services/public/collaboratorSessionService";

const route = useRoute();
const router = useRouter();

const loading = ref(true);
const errorMessage = ref("");

onMounted(async () => {
  const token = route.params.token;

  if (!token) {
    errorMessage.value = "Link inválido.";
    loading.value = false;
    return;
  }

  try {
    clearCollaboratorSession();

    const { data } = await resolveInvite({ token });

    const companyId = data.company?.id;
    const questionnaireVersionId = data.questionnaire?.version_id;

    const doneKey = getCollaboratorDoneKey(companyId, questionnaireVersionId);
    const alreadyDone = localStorage.getItem(doneKey) === "1";

    setCollaboratorInviteContext({
      invite_token: token,
      company: data.company,
      roles: data.roles || [],
      questionnaire: data.questionnaire || null,
    });

    if (alreadyDone) {
      router.replace({ name: "collab-form" });
      return;
    }

    router.replace({ name: "login-collab" });
  } catch (error) {
    errorMessage.value =
      error?.response?.data?.message || "Não foi possível validar o acesso.";
  } finally {
    loading.value = false;
  }
});
</script>
